module.exports = __webpack_public_path__ + "51cc543b75d33d110277d63667258e6f.png";